<template>
	<div class="parallax-horizontal__container">
		<div ref="asset" class="parallax-horizontal__asset">
			<slot name="asset"></slot>
		</div>
	</div>
</template>

<script>
import * as basicScroll from 'basicscroll';

export default {
	name: 'ParallaxHorizontal',
	mounted() {
		this.$nextTick(function () {
			const instance = basicScroll.create({
				elem: document.querySelector('.parallax-horizontal__asset'),
				from: 'top-bottom',
				to: 'bottom-top',
				props: {
					'--tx-left': {
						from: '300px',
						to: '0px',
					},
					'--tx-right': {
						from: '-300px',
						to: '0px',
					},
				},
			});
			instance.start();
		});
	},
};
</script>

<style lang="scss" scoped>
.parallax-horizontal__container {
	display: flex;
	min-height: 260px;

	@include tablet {
		min-height: 330px;
	}

	@include desktop {
		min-height: 460px;
	}

	&.-left {
		.parallax-horizontal__asset {
			transform: translateX(var(--tx-left));
		}
	}

	&.-right {
		.parallax-horizontal__asset {
			transform: translateX(var(--tx-right));
		}
	}
}
.parallax-horizontal__asset {
	display: flex;
}
</style>
